(function () {
    'use strict';

    a3_cabin_reports.factory('PreviousDutyFactory', PreviousDutyFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name PreviousDutyFactory
     * @ngInject
     */
    function PreviousDutyFactory(GenericService, $http, apiUrl) {
        function PreviousDuty() {
			this.FlightId = null;
            this.CrewId = null;
            this.PreviousDuty = null;
		}

        var objType ='previousDuty';
		var objCallback = PreviousDuty; 

        var service = {
            getPreviousDutiesFromStorage : getPreviousDutiesFromStorage,
            setPreviousDutiesToStorage : setPreviousDutiesToStorage,
            getPreviousDutyFromStorage : getPreviousDutyFromStorage,
            getFlightPreviousDutiesFromStorage : getFlightPreviousDutiesFromStorage,
            savePreviousDuty : savePreviousDuty,
            cleanOldData : cleanOldData,
            cleanFlightPreviousDuties : cleanFlightPreviousDuties,
            saveFlightPreviousDuties : saveFlightPreviousDuties
        };

         /**
         * Get Crew Phone Numbers.
         * @memberof PreviousDutyFactory
         * @returns {Array} PreviousDuties 
         */
		function getPreviousDutiesFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Get Crew Phone Numbers for specified flight
         * @memberof PreviousDutyFactory
         * @param {number} flightId
         * @returns {Array} PreviousDuties 
         */
		function getFlightPreviousDutiesFromStorage(flightId) {
			var previousDuties =  GenericService.list(objType,objCallback);
            return previousDuties.filter(x => x.FlightId == flightId);
		}

        /**
         * Save Crew Phone Numbers to storage
         * @memberof PreviousDutyFactory
         * @param {Array} PreviousDuties
         */
		function setPreviousDutiesToStorage(objList) {
			GenericService.saveAll(objList,objType);
        }

        /**
         * Get Previous Duty from storage 
         * @memberof PreviousDutyFactory
         * @param {number} crewId
         * @param {number} flightId
         * @return {object} previous duty info
         */
		function getPreviousDutyFromStorage(crewId, flightId) {
            var previousDuties = getPreviousDutiesFromStorage();

            return previousDuties.find(x => x.FlightId == flightId && x.CrewId == crewId);
		}
        
        /**
		 * Save a fetched previous duty
         * @memberof PreviousDutyFactory
		 * @param {object} previousDuty 
		 */
		function savePreviousDuty(previousDuty){
            GenericService.add(previousDuty, objType, objCallback);
		}

        /**
         * Clean ls from old flight previous duties
         * @param {array} flights Synced flights
         */
        function cleanOldData(responseFlightIds){
            var previousDuties = getPreviousDutiesFromStorage();
            //Filter out previous duties of old flights
            previousDuties = previousDuties.filter(x => responseFlightIds.includes(x.FlightId));
            
            setPreviousDutiesToStorage(previousDuties);
        }

        /**
         * Clean all stored previous duties for selected flight
         * @param {number} flightId 
         */
         function cleanFlightPreviousDuties(flightId){
            var previousDuties = getPreviousDutiesFromStorage();
			previousDuties = previousDuties.filter(x => x.FlightId != flightId);
			setPreviousDutiesToStorage(previousDuties); 
        }

        /**
         * Save previous duty info for each flight crew member that has one 
         * @param {number} flightId 
         * @param {array} crew 
         */
        function saveFlightPreviousDuties(flightId, crew){
				crew.forEach(function(user){
					if(user.PreviousDuty){
						var previousDuty = {
							FlightId : flightId,
							CrewId : user.id,
							PreviousDuty : user.PreviousDuty
						};
						savePreviousDuty(previousDuty);
					}
				});
        }

        return service;
    }
})();